export default __webpack_public_path__ + "static/media/posLogo.745186e8.jpg";